import $ from 'jquery';
$(document).ready(function(){
    var primaryNavigation = $('.navbar-primary');
    console.log(primaryNavigation.scrollTop());
});

$(window).scroll(function(){
    var scrollTop = $(window).scrollTop();
    var secondaryNavigationHeight = $('.navbar-secondary').height();
    $('.navbar-primary').toggleClass('scroll', scrollTop > 40)
})